import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { Div, H1, P, Input, Button } from '@driftt/tide-core'

import * as UserSelectors from 'modules/user/selectors'
import * as MetricsActions from 'modules/metrics/actions'

import { shuffle } from 'utils'
import { countAppMetric } from 'utils/metrics'
import { track, page } from 'utils/trackingUtils'

import './style.css'

const defaultSurveyOptions = [
  {
    isSelected: false,
    label: '💬 Chat with inbound leads',
  },
  {
    isSelected: false,
    label: '📆 Book meetings',
  },
  {
    isSelected: false,
    label: '📊 Keep track of open opportunities',
  },
  {
    isSelected: false,
    label: '📹 Create and send videos to prospects',
  },
]

const UnifiedSeatSurveyStep = ({ actions, flow }) => {
  const [surveyOptions, setSurveyOptions] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    page('Unified Seat Onboarding Survey')
    setSurveyOptions(shuffle(defaultSurveyOptions))
  }, [])

  const toggleOption = (label) => {
    if (selectedOptions.indexOf(label) > -1) {
      setSelectedOptions(selectedOptions.filter((item) => { return item !== label }))
    } else {
      setSelectedOptions([...selectedOptions, label])
    }
  }

  const advanceToNextStep = () => {
    if (JSON.stringify(selectedOptions) === JSON.stringify(['💬 Chat with inbound leads'])) {
      window.location.href = "/conversations"
    } else {
      window.location.href = "/activity"
    }
  }

  const submitSurvey = async () => {
    setIsSubmitting(true)

    // removing the emojis
    const cleanedSelectedOptions = selectedOptions.map(i => i.slice(2))
    track('Unified Onboarding Survey Submitted', { cleanedSelectedOptions })

    actions.sendDriftAppMetric(countAppMetric(`invitedUserFlow.completed.${flow}`, 'onboarding.'))
    
    setTimeout(advanceToNextStep, 1000)
  }

  return (
    <Div className="survey-container">
      <H1>
        What are you hoping to use Drift for?
      </H1>
      <P>Which parts of the sales cycle can Drift help you most with? Let us know and we’ll set you up for success. Choose everything that applies:</P>
      <Div className="survey-options-container">
        {surveyOptions.map((option, i) => {
          const optionLabel = option.label
          const isSelected = selectedOptions.indexOf(option.label) > -1
          return (
            <Div className={cx('survey-option', { 'selected' : isSelected })} onClick={() => toggleOption(optionLabel)} key={`video-survey-option-${i}`}>
              <Input 
                className="survey-option-input"
                type="checkbox" 
                label={option.label}
                checked={isSelected}
                key={`video-survey-option-${i}`}
                />
            </Div>
          )
        })}
      </Div>
      <Button 
        className="submit-survey-button" 
        loading={isSubmitting}
        disabled={!selectedOptions.length === 0}
        onClick={submitSurvey}>
        Launch my account
      </Button>
    </Div>
  )
}

const mapStateToProps = state => ({
  flow: UserSelectors.getFlow(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    sendDriftAppMetric: MetricsActions.sendDriftAppMetric,
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(UnifiedSeatSurveyStep)
